module.exports = __webpack_public_path__ + "media/reskin-images/icon--smartphone-2-9c5f981b.svg";